<template>
  <div class="inventory">
     <ul class="in_wamp">
      <li class="in_items" v-for="item in header" :key="item" style="padding:10px">{{ item }}</li>
    </ul>
    <ul class="wamp_ul">
      <li
        class="in_wamp"
        v-for="(item, index) in list"
        :key="index"
        style="padding: 10px"
      >
        <span class="in_items" v-for="(items, index2) in item" :key="index2">
          {{ items }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Inventory",
  data(){
    return{
      header : [],
      list : []
    }
  },
  mounted() {
    this.$axios.get(`${this.$url}/admin/bigpin9`).then((res) => {
      let datas = JSON.parse(res.data.split("<\/script>")[1]).data;
      this.header = datas.cols.map((item) => item.display_name);
      this.list = datas.rows;
    });
  },
};
</script>

<style lang="less">

.inventory{
  overflow: hidden;
}
.in_wamp {
  display: flex;
  color: white;
}
.in_items {
  flex: 1;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.title {
  margin: 0 auto;
  text-align: center;
  padding: 10px;
}
.wamp_ul{
  li:nth-child(2n+1){
    background-color: rgb(52,83,111);
  }
}

</style>